import {ISortableColumn} from 'app/client-core/dtos/sortable-column.model';
import { AuthUser } from './../../+auth/auth.user';
import { SiteConfig, CampaignThemeRecomendedListItemDto } from './../dtos/users.model';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';

import { ApiResponse, ApiPagedResponse, PaginationInfo } from "app/client-core/api-response-models";
import { ApiService } from "../api.service";
import { Bucket } from '../dtos/buckets.model';
import { Subject } from 'rxjs/Subject';
import { Router } from '@angular/router';
import { UserDto, CampaignThemeFavoriteListItemDto, TacticFavoriteListItemDto, UserRetailerListItemDto, Claim } from '../dtos/users.model';
import { CampaignThemeId } from '../dtos/campaigns.model';
import { TacticId } from '../dtos/tactics.model';
import { resetFakeAsyncZone } from '@angular/core/testing';
import { ClientSettingDto } from '../dtos/client-setting.model';

@Injectable()
export class UserService {

    public newUserAdded: Subject<any>;
    public tableColumnsUpdated: Subject<any>;
    
    constructor(private apiService: ApiService,
       private router: Router) {
        this.newUserAdded = new Subject<any>();
        this.tableColumnsUpdated = new Subject<any>();
    }

    /**
     * Returns lookup list of projects
     * @param params
     */
    getUsers(params?: any): Observable<ApiResponse<ApiPagedResponse<UserDto>>> {
        console.log('>>getUsers', JSON.stringify(params));
        return this.apiService.get<ApiPagedResponse<UserDto>>('users', params);
    }

    //getCurrentUser(): UserDto {
    //    let dto = new UserDto();
    //    dto.id = 4;
    //    return dto;
    //}

    getClaims(): Observable<ApiResponse<Claim[]>> {

        let response = this._getCachedClaims();
        if (response) {
            console.log('cache hit for getClaims');
            return Observable.of(response);
        }

        return this.apiService.get<Claim[]>('users/claims')
            .do(res => {
                if (!res.hasError && res.data) {
                    console.log('getClaims', res);
                    localStorage.setItem('claims', JSON.stringify(res.data));
                }
            });
    }

    public _getCachedClaims(): ApiResponse<Claim[]> {
        let claims = localStorage.getItem('claims');
        if (claims) {
            let response: ApiResponse<Claim[]> = new ApiResponse<Claim[]>();
            response.data = JSON.parse(claims);
            response.hasError = false;
            return response;
        }

        return null;
    }

    getCachedClaimsList(): Claim[] {
        const claims = localStorage.getItem('claims');
        if (claims) {
            return JSON.parse(claims);
        }
        return [];
    }

    getLocalSiteConfig(): Array<SiteConfig> {
        const configString = localStorage.getItem('site_config');
        if (configString) {
            return JSON.parse(configString);
        }
        return new Array<SiteConfig>();
    }

    getLocalClaims(): Array<Claim> {
        const configString = localStorage.getItem('claims');
        if (configString) {
            return JSON.parse(configString);
        }
        return new Array<Claim>();
    }

    getSiteConfig(): Observable<ApiResponse<SiteConfig[]>> {
        const response = this._getCachedSiteConfig();
        if (response) {
            console.log('cache hit for getSiteConfig');
            return Observable.of(response);
        }

        return this.apiService.get<SiteConfig[]>('users/siteconfig')
            .do(res => {
                if (!res.hasError && res.data) {
                    console.log('getSiteConfig', res);
                    localStorage.setItem('site_config', JSON.stringify(res.data));
                }
            });
    }

    getClientSettings(force: boolean = false): Promise<Array<ClientSettingDto>> {
        return new Promise((resolve, reject) => {
            const response = this._getCachedClientSettings();
            if (response && !force) {
                console.log('cache hit for getSiteConfig');
                return resolve(response);
            }

            this.apiService.get<ApiPagedResponse<ClientSettingDto>>('Customizationrequest/clientsettings')
                .do(res => {
                    if (!res.hasError && res.data) {
                        console.log('getSiteConfig', res);
                        localStorage.setItem('client_settings_cached', JSON.stringify(res.data.items));
                    }
                }).subscribe(resp => {
                    resolve(resp.data.items);
                });
        });
    }

    _getCachedClientSettings(): Array<ClientSettingDto> {
        const configString = localStorage.getItem('client_settings_cached');
        if (configString) {
            const values: ClientSettingDto[] = JSON.parse(configString)
            return values;
        }
        return null;
    }

    getClientSettingsFromLocalStorage(value): SiteConfig {
        const configString = localStorage.getItem('site_config');
        if (configString) {
            const values: SiteConfig[] = JSON.parse(configString)
            return values.find(c => c.configuration === value);
        }
        return null;
    }

    private _getCachedSiteConfig(): ApiResponse<SiteConfig[]> {
        const siteConfig = localStorage.getItem('site_config');
        if (siteConfig) {
            const response: ApiResponse<SiteConfig[]> = new ApiResponse<SiteConfig[]>();
            response.data = JSON.parse(siteConfig);
            response.hasError = false;
            return response;
        }

        return null;
    }

    //getClaims(): Observable<ApiResponse<Claim[]>> {
        //let userClaims: Array<Claim> = [
        //    { resource: 'customization', operation: 'create' },
        //    { resource: 'customization', operation: 'edit' },
        //    { resource: 'deliverylocation', operation: 'create' },
        //    { resource: 'finalization', operation: 'submit' }
        //];

        //let id = this.getCurrentUser().id;

        //console.log(`>>getClaims for ${id}`);

        //let response: ApiResponse<Claim[]> = new ApiResponse<Claim[]>();
        //response.data = userClaims;
        //response.hasError = false;

        //return Observable.of(response);
    //}

    getUser(id: number): Observable<ApiResponse<UserDto>> {
        //cache it if possible
        return this.apiService.get<UserDto>(`users/${id}`);
    }

    getUsersCampaginThemeFavorites(): Observable<ApiResponse<ApiPagedResponse<CampaignThemeFavoriteListItemDto>>> {
        return this.apiService.get<ApiPagedResponse<CampaignThemeFavoriteListItemDto>>(`users/campaign-theme-favorites`);
    }

    AddCampaginThemeAsFavorite(campaignThemeId: CampaignThemeId): Observable<ApiResponse<number>> {
        return this.apiService.post<number>(`users/campaign-theme/${campaignThemeId.id}/favorite`, {});
    }

    RemoveCampaginThemeFromFavorite(campaignThemeFavoriteId: number): Observable<ApiResponse<number>> {
        return this.apiService.delete<number>(`users/campaign-theme-favorite/${campaignThemeFavoriteId}`);
    }

    getUsersTacticFavorites(campaignThemeId): Observable<ApiResponse<ApiPagedResponse<TacticFavoriteListItemDto>>> {
        return this.apiService.get<ApiPagedResponse<TacticFavoriteListItemDto>>(`users/tactic-favorites?campaignThemeId=${campaignThemeId}`);
    }

    AddTacticAsFavorite(tacticId: TacticId): Observable<ApiResponse<number>> {
        return this.apiService.post<number>(`users/tactic/${tacticId.id}/favorite`, {});
    }

    RemoveTacticFromFavorite(tacticFavoriteId: number): Observable<ApiResponse<number>> {
        return this.apiService.delete<number>(`users/tactic-favorite/${tacticFavoriteId}`);
    }

    getUserRetailers(params?: any): Observable<ApiResponse<ApiPagedResponse<UserRetailerListItemDto>>> {
        console.log(`>>getUserRetailers`);
        return this.apiService.get<ApiPagedResponse<UserRetailerListItemDto>>(`users/retailers`, params);
    }

    saveUser(params: UserDto): Observable<ApiResponse<UserDto>> {
        if (params.id && params.id > 0) {
            return this.apiService.put<UserDto>(`users`, params);
        } else {
            return this.apiService.post<UserDto>(`users`, params);
        }
    }

    getRetailers(params?: any): Observable<ApiResponse<ApiPagedResponse<any>>> {
        return this.apiService.get<ApiPagedResponse<any>>(`users/lookup/retailers`, params);
    }

    getUserRoles(params?: any): Observable<ApiResponse<ApiPagedResponse<UserRetailerListItemDto>>> {
        return this.apiService.get<ApiPagedResponse<UserRetailerListItemDto>>(`users/lookup/userroles`, params);
    }

    getUsersLookup(params?: any): Observable<ApiResponse<ApiPagedResponse<UserRetailerListItemDto>>> {
        return this.apiService.get<ApiPagedResponse<UserRetailerListItemDto>>(`users/lookup/users`, params);
    }

    getUserToEdit(id: number): Observable<ApiResponse<UserDto>> {
        return this.apiService.get<UserDto>(`users/edit/${id}`);
    }

    getLoggedUserToEdit(): Observable<ApiResponse<UserDto>> {
        return this.apiService.get<UserDto>(`users/editloggeduser`);
    }

    getUsersCampaginThemeRecomended(): Observable<ApiResponse<ApiPagedResponse<CampaignThemeRecomendedListItemDto>>> {
        return this.apiService.get<ApiPagedResponse<CampaignThemeRecomendedListItemDto>>(`users/campaign-theme-recomended`);
    }

    saveLoggedUser(params: UserDto): Observable<any> {
        return this.apiService.put<UserDto>(`loggedusers`, params);
    }

    updatePassword(username, password, newPassword: string) {
        return this.apiService.postNewPwd('auth/NewPwd', username, password, newPassword);
    }

    getUserEmailList(params): Observable<ApiResponse<ApiPagedResponse<any>>> {
        console.log(`getting email list: `, params)
        return this.apiService.get<ApiPagedResponse<any>>(`users/email-list`, params);
    }

    getFirstRoute(): Observable<ApiResponse<string>> {
        return this.apiService.get<string>(`users/initial-route`, null);
    }

    getCognitoToken(code: string): Observable<ApiResponse<CognitoResponse>> {
        return this.apiService.get<CognitoResponse>(`users/cognito-token?code=${code}`, {});
    }

    getUserFormatColumns(retailerId: number): Observable<ApiResponse<ISortableColumn[]>> {
        return this.apiService.get<ISortableColumn[]>(`users/user-format-columns`, {
            retailerId
        });
    }

    updateUserFormatColumns(data: any): Observable<ApiResponse<boolean>> {
        return this.apiService.put<boolean>(`users/update-user-format-columns`, data);
    }
}

export interface CognitoResponse {
    id_token: string;
    access_token: string;
    refresh_token: string;
    expires_in: number;
    token_type: string;
}


// WEBPACK FOOTER //
// ./src/app/client-core/services/user.service.ts